import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { media, titleStyles, sectionStyles, mainContentStyles, contentStyles } from '../../styles/media';
import { Box } from '@mui/material';
import { ReactComponent as TDMAllLogo } from '../common/icons/TDM_all.svg';

const HeroSection = styled.section`
  ${sectionStyles}
  padding-top: 120px;
  position: relative;
  z-index: 1;
  background: #FFFFFF;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);

  ${media.xl`
    padding-top: 140px;
  `}
  
  ${media.lg`
    padding-top: 130px;
  `}
  
  ${media.md`
    padding-top: 120px;
  `}
  
  ${media.sm`
    padding-top: 110px;
  `}
`;

const MainContent = styled.div`
  ${mainContentStyles}
`;

const Content = styled.div`
  ${contentStyles}
`;

const LogoWrapper = styled.div`
  margin-bottom: 16px;
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  
  svg {
    width: 100%;
    height: auto;
    max-height: 180px;
    transition: transform 0.6s ease;
    
    &:hover {
      transform: scale(1.02);
    }
  }
  
  ${media.xl`
    max-width: 1000px;
    margin-bottom: 14px;
    
    svg {
      max-height: 160px;
    }
  `}
  
  ${media.lg`
    max-width: 800px;
    margin-bottom: 12px;
    
    svg {
      max-height: 140px;
    }
  `}
  
  ${media.md`
    max-width: 600px;
    margin-bottom: 10px;
    
    svg {
      max-height: 120px;
    }
  `}
  
  ${media.sm`
    max-width: 400px;
    margin-bottom: 8px;
    padding: 0 16px;
    
    svg {
      max-height: 100px;
    }
  `}
`;

const Title = styled.h1`
  font-size: clamp(60px, 6vw, 98px);
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: clamp(24px, 3vw, 32px);
  color: ${props => props.theme.colors.text.heading};
  
  .highlight {
    display: inline-block;
    color: #F8367D;
    background: rgba(255, 75, 143, 0.1);
    padding: 0 16px;
    border-radius: 100px;
  }
`;

const Description = styled.p`
  font-size: 20px;
  line-height: 1.6;
  color: #2B2D42;
  margin-bottom: 24px;
  max-width: 600px;
  
  ${media.lg`
    font-size: 18px;
    max-width: 480px;
    margin-bottom: 20px;
  `}
  
  ${media.md`
    font-size: 16px;
    max-width: 100%;
    margin-bottom: 16px;
  `}
  
  ${media.sm`
    font-size: 16px;
    text-align: center;
    margin: 0 auto 12px;
    padding: 0 16px;
  `}
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  
  ${media.lg`
    padding-right: 35%;
  `}
  
  ${media.md`
    padding-right: 0;
    padding: 0 16px;
  `}
`;

const Hero = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <HeroSection id="home">
        <MainContent>
          <Content>
            <LogoWrapper>
              <TDMAllLogo />
            </LogoWrapper>
            <Title>
              <div>{t('hero.title.line1')}</div>
              <div><span className="highlight">{t('hero.title.highlight')}</span></div>
              <div>{t('hero.title.line2')}</div>
            </Title>
            <Description>
              {t('hero.subtitle')}
            </Description>
          </Content>
        </MainContent>
      </HeroSection>
    </Box>
  );
};

export default Hero;